module.exports = __webpack_public_path__ + "img/iconfont.581a3838.svg";